module.exports = __webpack_public_path__ + "static/media/1011936.4d43bbbb.png";